Object.defineProperty(exports, '__esModule', { value: true });

var borderPaths = {
    16: {
        none: 'M15.5 8a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z',
        indicator: 'M8 .5c1 0 1.8.2 2.6.5.4 2.2 2.2 4 4.4 4.4A7.5 7.5 0 1 1 8 .5Z',
    },
    20: {
        none: 'M19.5 10a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0Z',
        indicator: 'M13.5 1.2c0 2.9 2.4 5.2 5.3 5.3a9.5 9.5 0 0 1-8.8 13 9.5 9.5 0 1 1 3.5-18.3Z',
    },
    24: {
        none: 'M23.5 12a11.5 11.5 0 1 1-23 0 11.5 11.5 0 0 1 23 0Z',
        indicator: 'M22 7.5c.4 0 .7.2.8.4A11.5 11.5 0 0 1 12 23.5a11.5 11.5 0 1 1 4-22.3c.3.1.5.4.5.8 0 3 2.5 5.5 5.5 5.5Z',
    },
    32: {
        none: 'M31.5 16a15.5 15.5 0 1 1-31 0 15.5 15.5 0 0 1 31 0Z',
        indicator: 'm29.2 7.9.4.7a15.5 15.5 0 1 1-5.5-5.8l.3.5.8 1.4c.5.9 1.2 1.6 2.1 2.1A63.3 63.3 0 0 1 29.2 8Z',
    },
    40: {
        top: 'M39.2 16.5v.6l.3 2.9A19.5 19.5 0 1 1 23.5.8c.5.2.9.6 1 1.2v1c0 6.9 5.6 12.5 12.5 12.5h1c.6.1 1 .5 1.2 1Z',
        bottom: 'M.5 20a19.5 19.5 0 1 1 38.7 3.5c-.2.5-.6.9-1.2 1h-1c-6.9 0-12.5 5.6-12.5 12.5v1c-.1.6-.5 1-1 1.2h-.6l-2.9.3A19.5 19.5 0 0 1 .5 20Z',
        topBottom: 'M24.5 2v1c0 6.9 5.6 12.5 12.5 12.5h1c.6.1 1 .5 1.2 1v.6a19.7 19.7 0 0 1 0 6.4c-.2.5-.6.9-1.2 1h-1c-6.9 0-12.5 5.6-12.5 12.5v1c-.1.6-.5 1-1 1.2h-.6l-2.9.3A19.5 19.5 0 1 1 23.5.8c.5.2.9.6 1 1.2Z',
        none: 'M.5 20a19.5 19.5 0 1 1 39 0 19.5 19.5 0 0 1-39 0Z',
        indicator: 'm36.7 10 .6 1A19.5 19.5 0 1 1 30 3.4l.3.5.7 1.6c.6 1.6 2 2.9 3.5 3.5a50.3 50.3 0 0 1 2.2 1Z',
        indicatorBottom: 'm30 3.3.3.6.7 1.6c.6 1.6 2 2.9 3.5 3.5a50.3 50.3 0 0 1 2.2 1l.6 1a19.4 19.4 0 0 1 1.9 12.5c-.2.5-.6.9-1.2 1h-1c-6.9 0-12.5 5.6-12.5 12.5v1c-.1.6-.5 1-1 1.2h-.6l-2.9.3A19.5 19.5 0 1 1 30 3.3Z',
    },
    48: {
        top: 'M45 15.5c.6 0 1 .3 1.2.8A23.5 23.5 0 1 1 31.7 1.8c.5.2.8.6.8 1.2 0 6.9 5.6 12.5 12.5 12.5Z',
        bottom: 'M46.2 31.7c-.2.5-.6.8-1.2.8-6.9 0-12.5 5.6-12.5 12.5 0 .6-.3 1-.8 1.2a23.5 23.5 0 1 1 14.5-14.5Z',
        topBottom: 'M24 .5c2.7 0 5.3.5 7.7 1.3.5.2.8.6.8 1.2 0 6.9 5.6 12.5 12.5 12.5.6 0 1 .3 1.2.8a23.5 23.5 0 0 1 0 15.4c-.2.5-.6.8-1.2.8-6.9 0-12.5 5.6-12.5 12.5 0 .6-.3 1-.8 1.2A23.5 23.5 0 1 1 24 .5Z',
        none: 'M47.5 24a23.5 23.5 0 1 1-47 0 23.5 23.5 0 0 1 47 0Z',
        indicator: 'm41.2 8.3 1 .8a23.5 23.5 0 1 1-3.3-3.3l.8 1c.4.6 1 1 1.5 1.5Z',
        indicatorBottom: 'm38.9 5.8.8 1c.4.6 1 1 1.5 1.5l1 .8a23.4 23.4 0 0 1 4 22.6c-.2.5-.6.8-1.2.8-6.9 0-12.5 5.6-12.5 12.5 0 .6-.3 1-.8 1.2A23.5 23.5 0 1 1 39 5.8Z',
    },
    56: {
        top: 'M52 16.5c.6 0 1.1.3 1.3.8A27.4 27.4 0 0 1 28 55.5 27.5 27.5 0 1 1 38.7 2.7c.5.2.8.7.8 1.3 0 6.9 5.6 12.5 12.5 12.5Z',
        bottom: 'M53.3 38.7c-.2.5-.7.8-1.3.8-6.9 0-12.5 5.6-12.5 12.5 0 .6-.3 1.1-.8 1.3A27.4 27.4 0 0 1 .5 28a27.5 27.5 0 1 1 52.8 10.7Z',
        topBottom: 'M28 .5c3.8 0 7.4.8 10.7 2.2.5.2.8.7.8 1.3 0 6.9 5.6 12.5 12.5 12.5.6 0 1.1.3 1.3.8a27.4 27.4 0 0 1 0 21.4c-.2.5-.7.8-1.3.8-6.9 0-12.5 5.6-12.5 12.5 0 .6-.3 1.1-.8 1.3A27.4 27.4 0 0 1 .5 28 27.5 27.5 0 0 1 28 .5Z',
        none: 'M55.5 28a27.5 27.5 0 1 1-55 0 27.5 27.5 0 0 1 55 0Z',
        indicator: 'm47.8 9 .4.3a27.5 27.5 0 1 1-.4-.4Z',
        indicatorBottom: 'm46.7 7.8.4.4.7.7.4.4a27.4 27.4 0 0 1 5.1 29.4c-.2.5-.7.8-1.3.8-6.9 0-12.5 5.6-12.5 12.5 0 .6-.3 1.1-.8 1.3A27.4 27.4 0 0 1 .5 28 27.5 27.5 0 0 1 46.7 7.8Z',
    },
    64: {
        top: 'M59 20.5c1.4 0 2.6.7 3 1.9A31.5 31.5 0 1 1 41.6 2c1.2.4 1.9 1.6 1.9 3 0 8.6 7 15.5 15.5 15.5Z',
        bottom: 'M62 41.6c-.4 1.2-1.6 1.9-3 1.9-8.6 0-15.5 7-15.5 15.5 0 1.4-.7 2.6-1.9 3A31.5 31.5 0 1 1 62 41.6Z',
        topBottom: 'M32 .5c3.4 0 6.6.5 9.6 1.5 1.2.4 1.9 1.6 1.9 3 0 8.6 7 15.5 15.5 15.5 1.4 0 2.6.7 3 1.9a31.5 31.5 0 0 1 0 19.2c-.4 1.2-1.6 1.9-3 1.9-8.6 0-15.5 7-15.5 15.5 0 1.4-.7 2.6-1.9 3A31.5 31.5 0 1 1 32 .5Z',
        none: 'M63.5 32a31.5 31.5 0 1 1-63 0 31.5 31.5 0 0 1 63 0Z',
        indicator: 'M63.5 32a31.5 31.5 0 1 1-63 0 31.5 31.5 0 0 1 63 0Z',
        indicatorBottom: 'M63.5 32c0 3.4-.5 6.6-1.5 9.6-.4 1.2-1.6 1.9-3 1.9-8.6 0-15.5 7-15.5 15.5 0 1.4-.7 2.6-1.9 3a31.5 31.5 0 1 1 21.9-30Z',
    },
    80: {
        top: 'M71 24.5c3 0 6 1.1 6.7 3.7a39.5 39.5 0 1 1-25.9-26c2.6.9 3.7 3.8 3.7 6.8 0 8.6 7 15.5 15.5 15.5Z',
        bottom: 'M77.7 51.8c-.8 2.6-3.7 3.7-6.7 3.7-8.6 0-15.5 7-15.5 15.5 0 3-1.1 6-3.7 6.7a39.5 39.5 0 1 1 26-25.9Z',
        topBottom: 'M51.8 2.3C54.4 3 55.5 6 55.5 9c0 8.6 7 15.5 15.5 15.5 3 0 6 1.1 6.7 3.7a39.5 39.5 0 0 1 0 23.6c-.8 2.6-3.7 3.7-6.7 3.7-8.6 0-15.5 7-15.5 15.5 0 3-1.1 6-3.7 6.7a39.5 39.5 0 1 1 0-75.4Z',
        none: 'M79.5 40a39.5 39.5 0 1 1-79 0 39.5 39.5 0 0 1 79 0Z',
        indicator: 'M79.5 40a39.5 39.5 0 1 1-79 0 39.5 39.5 0 0 1 79 0Z',
        indicatorBottom: 'M79.5 40c0 4.1-.6 8-1.8 11.8-.8 2.6-3.7 3.7-6.7 3.7-8.6 0-15.5 7-15.5 15.5 0 3-1.1 6-3.7 6.7A39.5 39.5 0 1 1 79.5 40Z',
    },
    128: {
        bottom: 'M122.8 88.1c-1 2.3-3.5 3.5-6.2 3.4h-.6a24.5 24.5 0 0 0-24.5 25.1c0 2.7-1 5.2-3.4 6.2a63.5 63.5 0 1 1 34.6-34.6Z',
        topBottom: 'M91.5 11.4h.5-.5v.6a24.5 24.5 0 0 0 25.1 24.5c2.7 0 5.2 1 6.2 3.4a63.3 63.3 0 0 1 0 48.2c-1 2.3-3.5 3.5-6.2 3.4h-.6a24.5 24.5 0 0 0-24.5 25.1c0 2.7-1 5.2-3.4 6.2a63.5 63.5 0 1 1 0-117.5c2.3.9 3.5 3.4 3.4 6Z',
        none: 'M127.5 64a63.5 63.5 0 1 1-127 0 63.5 63.5 0 0 1 127 0Z',
        top: 'M91.5 11.4h.5-.5v.6a24.5 24.5 0 0 0 25.1 24.5c2.7 0 5.2 1 6.2 3.4A63.5 63.5 0 1 1 88.2 5.3c2.2.9 3.4 3.4 3.3 6Z',
    },
};
var shapePaths = {
    16: {
        none: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z',
        indicator: 'M11 .6A8 8 0 0 0 0 8a8 8 0 1 0 15.4-3A5 5 0 0 1 11 .6Z',
    },
    20: {
        none: 'M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z',
        indicator: 'M19.2 6.2 19 6a5 5 0 0 1-5-5c0-.1 0-.2-.2-.2A10 10 0 0 0 0 10a10 10 0 1 0 19.2-3.8Z',
    },
    24: {
        none: 'M24 12a12 12 0 1 1-24 0 12 12 0 0 1 24 0Z',
        indicator: 'M23.2 7.7C23 7.2 22.5 7 22 7a5 5 0 0 1-5-5c0-.5-.2-1-.7-1.2A12 12 0 0 0 0 12a12 12 0 1 0 23.2-4.3Z',
    },
    32: {
        none: 'M32 16a16 16 0 1 1-32 0 16 16 0 0 1 32 0Z',
        indicator: 'm30 8.4-.5-.9-2-1.1a5 5 0 0 1-1.9-2l-1.1-2-.9-.5a16 16 0 1 0 6.5 6.5Z',
    },
    40: {
        top: 'm39.8 17-.1-.6A2 2 0 0 0 38 15H37A12 12 0 0 1 25 3V1.9A2 2 0 0 0 23.6.3H23A20 20 0 1 0 39.7 17Z',
        bottom: 'M20 0a20 20 0 1 0 3.6 39.7A2 2 0 0 0 25 38V37a12 12 0 0 1 12-12h1.1a2 2 0 0 0 1.6-1.4V23A20 20 0 0 0 20 0Z',
        topBottom: 'M25 3V1.9A2 2 0 0 0 23.6.3H23a20 20 0 1 0 .7 39.4A2 2 0 0 0 25 38V37a12 12 0 0 1 12-12h1.1a2 2 0 0 0 1.6-1.4V23a20.2 20.2 0 0 0 0-6.5A2 2 0 0 0 38 15H37A12 12 0 0 1 25 3Z',
        none: 'M0 20a20 20 0 1 1 40 0 20 20 0 0 1-40 0Z',
        indicator: 'M37.7 10.7c-.3-.6-.4-.8-.7-1-.3-.3-1-.6-2.3-1.1a6 6 0 0 1-3.3-3.3l-1-2.3-1.1-.7a20 20 0 1 0 8.5 8.5Z',
        indicatorBottom: 'm31.4 5.3-1-2.3-1.1-.7a20 20 0 1 0-5.6 37.4A2 2 0 0 0 25 38V37a12 12 0 0 1 12-12h1.1a2 2 0 0 0 1.6-1.4V23A20.2 20.2 0 0 0 37 9.6l-2.3-1a6 6 0 0 1-3.3-3.3Z',
    },
    48: {
        top: 'M46.7 16c-.3-.6-1-1-1.7-1A12 12 0 0 1 33 3c0-.7-.4-1.4-1-1.7a24 24 0 1 0 14.7 14.8Z',
        bottom: 'M45 33c.7 0 1.4-.4 1.7-1a24 24 0 1 0-14.8 14.7c.7-.3 1.1-1 1.1-1.7a12 12 0 0 1 12-12Z',
        topBottom: 'M24 0c2.8 0 5.4.5 8 1.3.6.3 1 1 1 1.7a12 12 0 0 0 12 12c.7 0 1.4.4 1.7 1a24 24 0 0 1 0 16c-.3.6-1 1-1.7 1a12 12 0 0 0-12 12c0 .7-.4 1.4-1 1.7A24 24 0 1 1 24 0Z',
        none: 'M48 24a24 24 0 1 1-48 0 24 24 0 0 1 48 0Z',
        indicator: 'm42.6 8.8-1-1A6 6 0 0 1 40 6.6c-.3-.4-.5-.8-1-1a24 24 0 1 0 3.4 3.4Z',
        indicatorBottom: 'M40.1 6.5c-.3-.4-.5-.8-1-1a24 24 0 1 0-7.3 41.3c.8-.4 1.2-1 1.2-1.8a12 12 0 0 1 12-12c.7 0 1.4-.4 1.7-1a24 24 0 0 0-4.1-23.2l-1-1A6 6 0 0 1 40 6.6Z',
    },
    56: {
        top: 'M52 16a2 2 0 0 1 1.8 1.1A28 28 0 0 1 28 56 28 28 0 1 1 38.9 2.2 2 2 0 0 1 40 4a12 12 0 0 0 12 12Z',
        bottom: 'M52 40a2 2 0 0 0 1.8-1.1A28 28 0 0 0 28 0a28 28 0 1 0 10.9 53.8A2 2 0 0 0 40 52a12 12 0 0 1 12-12Z',
        topBottom: 'M28 0c3.9 0 7.6.8 10.9 2.2A2 2 0 0 1 40 4a12 12 0 0 0 12 12 2 2 0 0 1 1.8 1.1 28 28 0 0 1 0 21.8A2 2 0 0 1 52 40a12 12 0 0 0-12 12 2 2 0 0 1-1.1 1.8A28 28 0 0 1 0 28 28 28 0 0 1 28 0Z',
        none: 'M56 28a28 28 0 1 1-56 0 28 28 0 0 1 56 0Z',
        indicator: 'm48.5 9-.4-.4a6 6 0 0 1-.7-.7l-.4-.4A27.9 27.9 0 0 0 0 28 28 28 0 1 0 48.5 9Z',
        indicatorBottom: 'M47.4 8A27.9 27.9 0 0 0 0 28a28 28 0 0 0 38.9 25.8A2 2 0 0 0 40 52a12 12 0 0 1 12-12 2 2 0 0 0 1.8-1.1 28 28 0 0 0-6.4-31Z',
    },
    64: {
        top: 'M62.5 22.2c-.5-1.4-2-2.2-3.5-2.2A15 15 0 0 1 44 5c0-1.5-.8-3-2.2-3.5a32 32 0 1 0 20.7 20.7Z',
        bottom: 'M59 44c1.5 0 3-.8 3.5-2.2a32 32 0 1 0-20.7 20.7c1.4-.5 2.2-2 2.2-3.5a15 15 0 0 1 15-15Z',
        topBottom: 'M32 0c3.4 0 6.7.5 9.8 1.5C43.2 2 44 3.5 44 5a15 15 0 0 0 15 15c1.5 0 3 .8 3.5 2.2a32 32 0 0 1 0 19.6c-.5 1.4-2 2.2-3.5 2.2a15 15 0 0 0-15 15c0 1.5-.8 3-2.2 3.5A32 32 0 1 1 32 0Z',
        none: 'M64 32a32 32 0 1 1-64 0 32 32 0 0 1 64 0Z',
        indicator: 'M32 64a32 32 0 1 0 0-64 32 32 0 0 0 0 64Z',
        indicatorBottom: 'M64 32a32 32 0 0 1-1.5 9.8c-.5 1.4-2 2.2-3.5 2.2a15 15 0 0 0-15 15c0 1.5-.8 3-2.2 3.5A32 32 0 1 1 64 32Z',
    },
    80: {
        top: 'M78.2 28c-1-2.8-4.2-4-7.2-4A15 15 0 0 1 56 9c0-3-1.2-6.3-4-7.2A40 40 0 1 0 78.2 28Z',
        bottom: 'M71 56c3 0 6.3-1.2 7.2-4A40 40 0 1 0 52 78.2c2.8-1 4-4.2 4-7.2a15 15 0 0 1 15-15Z',
        topBottom: 'M56 9c0-3-1.2-6.3-4-7.2a40 40 0 1 0 0 76.4c2.8-1 4-4.2 4-7.2a15 15 0 0 1 15-15c3 0 6.3-1.2 7.2-4a40 40 0 0 0 0-24c-1-2.8-4.2-4-7.2-4A15 15 0 0 1 56 9Z',
        none: 'M80 40a40 40 0 1 1-80 0 40 40 0 0 1 80 0Z',
        indicator: 'M40 80a40 40 0 1 0 0-80 40 40 0 0 0 0 80Z',
        indicatorBottom: 'M80 40a40 40 0 0 1-1.8 12c-1 2.8-4.2 4-7.2 4a15 15 0 0 0-15 15c0 3-1.2 6.3-4 7.2A40 40 0 1 1 80 40Z',
    },
    128: {
        top: 'M123.2 39.7c-1-2.6-3.8-3.8-6.6-3.7h-.6a24 24 0 0 1-24-24.6c0-2.8-1.1-5.6-3.7-6.6a64 64 0 1 0 35 35Z',
        bottom: 'M116.6 92c2.8 0 5.6-1.1 6.6-3.7a64 64 0 1 0-35 35c2.7-1.1 3.9-4 3.8-6.7v-.6a24 24 0 0 1 24.6-24Z',
        topBottom: 'M92 11.4c0-2.8-1.1-5.6-3.7-6.6a64 64 0 1 0 0 118.4c2.6-1 3.8-3.8 3.7-6.6v-.6a24 24 0 0 1 24.6-24c2.8 0 5.6-1.1 6.6-3.7a63.8 63.8 0 0 0 0-48.6c-1-2.6-3.8-3.8-6.6-3.7h-.6a24 24 0 0 1-24-24.6Z',
        none: 'M128 64A64 64 0 1 1 0 64a64 64 0 0 1 128 0Z',
    },
};
var pathsMap = {
    shape: shapePaths,
    border: borderPaths,
};

exports.borderPaths = borderPaths;
exports.pathsMap = pathsMap;
exports.shapePaths = shapePaths;
